import { useTranslation } from "react-i18next";
import { useSearch } from "wouter";
import { Layout } from "@/components/layout";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, Mail, Clock, MessageCircle } from "lucide-react";
import { StepIndicator } from "@/components/onboarding/StepIndicator";

export default function Processing() {
  const { t } = useTranslation();
  const search = useSearch();
  const urlParams = new URLSearchParams(search);
  const customerCount = parseInt(urlParams.get("count") || "0", 10);

  return (
    <Layout hideSidebar>
      <div className="max-w-4xl mx-auto">
        <StepIndicator currentStep={3} totalSteps={3} />
        <div className="text-center mb-12 space-y-4">
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-primary/10 rounded-full">
              <CheckCircle2 className="h-12 w-12 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold">{t("pages.pcOnboarding.processing.invitesReceived")}</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t("pages.pcOnboarding.processing.weVeReceivedYour")}
          </p>
        </div>

        <Card className="border-2">
          <CardContent className="pt-6">
            <div className="space-y-6">
              {customerCount > 0 && (
                <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-4">
                  <p className="text-lg font-semibold text-foreground">
                    {customerCount} contractor{customerCount > 1 ? "s" : ""}{" "}
                    submitted
                  </p>
                  <p className="text-sm text-muted-foreground mt-1">
                    {t("pages.pcOnboarding.processing.weReProcessing")}{" "}
                    {customerCount === 1
                      ? t("pages.pcOnboarding.processing.thisContractorS")
                      : t("pages.pcOnboarding.processing.theseContractors")}{" "}
                    {t("pages.pcOnboarding.processing.accountSetupNow")}
                  </p>
                </div>
              )}

              <div className="space-y-4 text-muted-foreground">
                <p className="leading-relaxed text-lg">
                  {t("pages.pcOnboarding.processing.thankYouForSubmitting")}
                </p>

                <div className="space-y-3 pt-4">
                  <div className="flex items-start gap-3">
                    <Clock className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-foreground">
                        {t("pages.pcOnboarding.processing.whatHappensNext")}
                      </p>
                      <p className="text-sm">
                        {t("pages.pcOnboarding.processing.weLlCreateContractor")}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Mail className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-foreground">
                        {t("pages.pcOnboarding.processing.emailNotifications")}
                      </p>
                      <p className="text-sm">
                        {t("pages.pcOnboarding.processing.yourContractorsWillReceive")}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <MessageCircle className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-foreground">{t("pages.pcOnboarding.processing.needHelp")}</p>
                      <p className="text-sm">
                        {t("pages.pcOnboarding.processing.ifYouHaveAny")}{" "}
                        <a
                          href="mailto:support@onsemble.com"
                          className="text-primary hover:underline font-medium"
                        >
                          support@onsemble.com
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
